/*
 * Local Skip Bin Hire — premium marketplace interactions
 * Unpublished duplicate theme only
 */

(function () {
  "use strict";

  document.documentElement.setAttribute("data-lsbh-marketplace", "ready");

  function prefersReducedMotion() {
    return (
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
    );
  }

  function focusSizeStep() {
    if (window.matchMedia && !window.matchMedia("(max-width: 749px)").matches) {
      return false;
    }

    var sizeStep = document.getElementById("bk-s-size");

    if (!sizeStep || !sizeStep.classList.contains("active")) {
      return false;
    }

    var destination =
      window.scrollY + sizeStep.getBoundingClientRect().top - 12;

    window.scrollTo({
      top: Math.max(0, destination),
      behavior: prefersReducedMotion() ? "auto" : "smooth",
    });

    return true;
  }

  function scheduleSizeStepFocus() {
    var attempts = 0;

    function tryFocus() {
      if (focusSizeStep()) {
        return;
      }

      attempts += 1;

      if (attempts < 4) {
        window.setTimeout(tryFocus, 80);
      }
    }

    window.setTimeout(tryFocus, 40);
  }

  document.addEventListener(
    "click",
    function (event) {
      var target =
        event.target instanceof Element
          ? event.target.closest("#bk-wastelist .bk-card[data-waste-key]")
          : null;

      if (target) {
        scheduleSizeStepFocus();
      }
    },
    false,
  );
})();
